/**
 * @generated SignedSource<<4573f96d5c5c9e9e4a2b52313568f5a8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RoutineEditMainConvertToWeeklyMutation$variables = {
  id: string;
};
export type RoutineEditMainConvertToWeeklyMutation$data = {
  readonly routine: {
    readonly convertToWeekly: {
      readonly routine: {
        readonly currentSchedule: {
          readonly __typename: string;
        } | null;
        readonly id: string;
      } | null;
    } | null;
  } | null;
};
export type RoutineEditMainConvertToWeeklyMutation = {
  response: RoutineEditMainConvertToWeeklyMutation$data;
  variables: RoutineEditMainConvertToWeeklyMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "RoutineMutation",
    "kind": "LinkedField",
    "name": "routine",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UpdateRoutinePayload",
        "kind": "LinkedField",
        "name": "convertToWeekly",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Routine",
            "kind": "LinkedField",
            "name": "routine",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "currentSchedule",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RoutineEditMainConvertToWeeklyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RoutineEditMainConvertToWeeklyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "404879480244e916d643b3464b3411d6",
    "id": null,
    "metadata": {},
    "name": "RoutineEditMainConvertToWeeklyMutation",
    "operationKind": "mutation",
    "text": "mutation RoutineEditMainConvertToWeeklyMutation(\n  $id: ID!\n) {\n  routine(id: $id) {\n    convertToWeekly {\n      routine {\n        id\n        currentSchedule {\n          __typename\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "10f12ae6d09a144ae998ac7de8b140f8";

export default node;
